import DeviceCleaningImportance from './DeviceCleaningImportance';
export default DeviceCleaningImportance;
